import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import ro from "./locales/ro.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import it from "./locales/it.json";

export const SUPPORTED_LOCALES = ["en", "ro", "es", "fr", "de", "it"];
export const DEFAULT_LOCALE = "en";

// Map ISO country codes (from IP geolocation) to our locales.
// Keep narrow — falls back to 'en' for everything not listed.
export const COUNTRY_TO_LOCALE = {
  RO: "ro",
  MD: "ro",
  IT: "it",
  ES: "es",
  AR: "es", MX: "es", CO: "es", CL: "es", PE: "es", VE: "es",
  FR: "fr",
  BE: "fr",
  DE: "de",
  AT: "de",
  CH: "de"
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ro: { translation: ro },
      es: { translation: es },
      fr: { translation: fr },
      de: { translation: de },
      it: { translation: it }
    },
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES,
    interpolation: { escapeValue: false },
    detection: {
      // URL path segment first (/ro/..., /it/...), then cookie, then navigator.
      // IP geo runs in lib/geo.js and writes the cookie before render.
      order: ["path", "cookie", "navigator"],
      lookupFromPathIndex: 0,
      caches: ["cookie"],
      cookieMinutes: 60 * 24 * 90
    }
  });

export default i18n;
